/* eslint-disable no-unused-vars */
export const black = '#000000';
export const white = '#ffffff';
export const red = '#ff3334';
export const lightGray = '#ededed';
export const anthracite = '#333f48';
export const darkGray = '#bcbcbc';
export const darkBlue = '#0f1d40';
export const lightBlue = '#5c7ca3';
export const grey = '#D8D8D8';
